import { Reservation } from '@monorepo/functions/src/types/reservations'

export const isReservationActive = (reservation: Reservation): boolean => {
    const now = new Date().toISOString()

    if (reservation.status === 'cancelled') return false

    const isActive = reservation.type === 'hotel' ? reservation.checkOutDate >= now : reservation.date >= now

    return isActive
}

export const isReservationActiveToday = (reservation: Reservation): boolean => {
    if (!isReservationActive(reservation)) return false

    const now = new Date().toISOString()

    if (reservation.type === 'hotel') {
        return reservation.checkOutDate >= now && reservation.checkInDate <= now
    }

    return reservation.date >= now
}
